//
import { RFormFields } from '@/components/reusable_components/next'
import CustomerModel from '@/models/Sale/SlCustomer'
import UserModel from '@/models/General/GUser'

/**
 * SlCustomerAccountReceivalbeHeaders
 */
export default RFormFields
  .from([
    {
      name: 'number',
      type: 'text-field',
      props: {
        label: 'Factura',
      },
    },
    {
      name: 'g_seller_user_id',
      type: 'autocomplete-model',
      props: {
        itemText: 'hr_employee_name_case',
        itemValue: 'id',
        label: 'Vendedor',
        model: UserModel,
        noObject: true,
      },
    },
    {
      name: 'sl_customer_id',
      type: 'autocomplete-model',
      props: {
        itemText: 'alias_name',
        itemValue: 'id',
        label: 'Cliente',
        model: CustomerModel,
        noObject: true,
      },
      trigger(ctx) {
        ctx.getField('sl_customer_branch_offices_id').props.items = ctx.getInput('sl_customer_id').getSelected().branch_offices
        ctx.$forceUpdate()
      },
    },
    {
      name: 'sl_customer_branch_offices_id',
      type: 'select',
      props: {
        label: 'Sucursal',
        items: [],
        itemText: 'address',
        itemValue: 'id',
        noObject: true,
      },
    },
    {
      name: 'status',
      type: 'select',
      props: {
        items: [
          'Pendiente',
          'Abonado',
          'Pagado',
          'Atrasado',
        ],
        label: 'Estado',
      },
    },
    {
      name: 'pay_date',
      type: 'date-field',
      props: {
        label: 'Vencimiento',
      },
    },
    {
      name: 'pay_date_min',
      type: 'date-field',
      props: {
        label: 'Desde',
      },
    },
    {
      name: 'pay_date_max',
      type: 'date-field',
      props: {
        label: 'Hasta',
      },
    },
  ])
